module.exports = __webpack_public_path__ + "img/restaurant-3.eef5e7ab.jpg";